module.exports = __webpack_public_path__ + "img/cake.96711cc3.png";